import type { SVGProps } from "react";

export function IconBlackFinger(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M39.5 18.5C39.5 14.787 38.025 11.226 35.3995 8.60051C32.774 5.975 29.213 4.5 25.5 4.5C21.787 4.5 18.226 5.975 15.6005 8.6005C12.975 11.226 11.5 14.787 11.5 18.5"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.5001 13.25C22.6005 13.25 20.25 15.6005 20.25 18.5V40.1894L17.6872 37.6265C14.2701 34.2094 8.72989 34.2094 5.31281 37.6265L3.43933 39.5L16.7834 52.8441C19.9246 55.9853 24.1851 57.75 28.6274 57.75H57.7501V34.7C57.7501 34.6263 57.7416 34.5543 57.7255 34.4852C57.7418 34.3254 57.7501 34.1636 57.7501 34C57.7501 31.3766 55.6234 29.25 53.0001 29.25C50.91 29.25 49.1353 30.5998 48.5001 32.4753C47.8648 30.5998 46.0901 29.25 44.0001 29.25C41.91 29.25 40.1353 30.5998 39.5001 32.4753C38.8648 30.5998 37.0901 29.25 35.0001 29.25C33.14 29.25 31.5297 30.3191 30.7501 31.8763V18.5C30.7501 15.6005 28.3996 13.25 25.5001 13.25Z"
        fill="#23232C"
      />
    </svg>
  );
}
